"use strict";

// ---------------------------------------------------
// Load Super Class
var Backbone = require('dibs-backbone');
var SoaModel = require('bunsen/models/SoaModel');

// ---------------------------------------------------
// Module Definition

/** Model for Attribute data that is placed on Item model, e.g.:
 * {
 *     "value": Costa Rica",
 *     "option": {
 *         "id": 7595
 *     }
 * }
 * @class ItemAttribute
 * @extends SoaModel
 */
var ItemAttribute = module.exports = SoaModel.extend();

// ---------------------------------------------------
// Dependencies

var _ = require('underscore');
var ItemAttributes = require('bunsen/collections/inventory/ItemAttributes');

// ---------------------------------------------------
// Local Vars

// ---------------------------------------------------
// Define Module Instance Properties

_.extend(ItemAttribute.prototype, {
    idAttribute:'option.id',
    defaults : {
        option : {}
    },
    relations : [
        {
            type: Backbone.One,
            key: 'option',
            relatedModel: SoaModel.extend({
                relations: [
                    {
                        type: Backbone.One,
                        key: 'displayConfigs',
                        relatedModel: SoaModel.extend()
                    }
                ]
            })

        },
        {
            type: Backbone.Many,
            key: 'child',
            collectionType: ItemAttributes
        }
    ],
    /**
     * Pick only necessary information to avoid setting extraneous data on Item when getting saved Item data
     * @param response
     * @returns {{value: *, option: {id: *}, groupKey: (*|null)}}
     */
    parse : function (response) {
        return {
            value: response.value,
            option: {
                id: response.option ? response.option.id : null,
                urlLabel: response.option ? response.option.urlLabel : null,
                displayConfigs: response.option ? response.option.displayConfigs : null
            },
            groupKey: response.groupKey || null,
            text: response.text
        };
    },

    /**
     * @returns {*}
     */
    getMaterialAttribute: function () {
        return this.get(ItemAttribute.ATTRIBUTE_MATERIAL);
    },

    /**
     * @returns {*}
     */
    getTechniqueAttribute: function () {
        return this.get(ItemAttribute.ATTRIBUTE_TECHNIQUE);
    }
});

// ---------------------------------------------------
// Define Module Static Properties

_.extend(ItemAttribute, {
    ATTRIBUTE_KEY               : 'attributes',
    ATTRIBUTE_MATERIAL          : 'material',
    ATTRIBUTE_TECHNIQUE         : 'technique',
    ATTRIBUTE_METAL             : 'metal',
    ATTRIBUTE_STONE             : 'stone',
    ATTRIBUTE_STYLE             : 'style',
    ATTRIBUTE_STYLE_OF          : 'style_of',
    ATTRIBUTE_ORIGIN            : 'origin',
    ATTRIBUTE_PERIOD            : 'period',
    ATTRIBUTE_LEAD_TIME         : 'lead_time',
    ATTRIBUTE_PRODUCTION_TYPE   : 'production_type',
    ATTRIBUTE_COLOR             : 'color'
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/inventory/ItemAttribute.js
// module id = 1219
// module chunks = 64